<template>
  <li
    class="anz-posts__item"
    :class="{
      'anz-posts__item--advert': advert && advert.renderAfter,
    }"
  >
    <template v-if="advert && !advert.renderAfter">
      <advert-position :advert="advert" :key="advert.divId"> </advert-position>
    </template>
    <post-single
      v-if="postRoot.post"
      :post-root="postRoot"
      @post-responded="postResponded($event)"
      show-report-button
      show-subscribe-button
      highlight-mine
      :open-respond-page="openRespondPage"
    >
    </post-single>
    <template v-if="advert && advert.renderAfter && postRoot.fullyLoaded">
      <advert-position :advert="advert" :key="advert.divId"> </advert-position>
    </template>
  </li>
</template>

<script lang="ts">
import { computed, defineComponent, Ref, ref } from 'vue'
import PostSingle from '@/components/Post/PostSingle.vue'
import { Post } from '@/model/data-object/Post'
import AdvertPosition from '@/components/Post/AdvertPosition.vue'
import useAdvertManager from '@/composables/advert/advertManager'

export default defineComponent({
  name: 'PostFlatBranch',
  components: { AdvertPosition, PostSingle },
  emits: ['post-responded'],
  props: {
    postRoot: {
      type: Object, // todo retype to postRoot
      required: true,
    },
    openRespondPage: {
      type: Boolean,
      default: false,
    },
  },
  async setup(props, context) {
    const isTopLevelNonRoot: Ref<boolean> = ref<boolean>(false)
    const { advertPositionsList } = useAdvertManager()

    isTopLevelNonRoot.value =
      props.postRoot.post && props.postRoot.post.parent !== null

    const postResponded = function(post: Post) {
      context.emit('post-responded', post)
    }

    const advert = computed(() => {
      if (props.postRoot.id in advertPositionsList) {
        return advertPositionsList[props.postRoot.id]
      }
    })

    return {
      isTopLevelNonRoot,
      advert,
      postResponded,
    }
  },
})
</script>
